export const fetchAvailableStatYears = async (): Promise<string[]> => {
  const response = await fetch('/content/old/years.json');
  if (!response.ok) {
    throw new Error('Unable to load available statistics seasons.');
  }

  const data = (await response.json()) as { years?: unknown };
  if (!Array.isArray(data.years) || !data.years.every((year) => typeof year === 'string')) {
    throw new Error('The available statistics seasons list is invalid.');
  }

  return data.years;
};
